import { styled } from '@mui/material/styles';
import { gutterFlexible, neutral } from '@style/variables.js';
import { Typography } from '@mui/material';
import { ToutContent as BaseToutContent } from '@repo/ui/src/components/ToutContent';
import isPropValid from '@emotion/is-prop-valid';

export const Banner = styled('div', { shouldForwardProp: isPropValid })<{ heroImageUrl: string }>(
  ({ theme, heroImageUrl }) => `
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    zIndex: 1;
    background-image: url("${heroImageUrl}");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 5rem ${Number(gutterFlexible) * 2}vw;
    margin-bottom: 3rem;

    @media screen and (min-width: ${theme.breakpoints.values['sm']}px) and (min-height: 700px) {
      margin-bottom: 5rem;
      padding-top: 9rem;
      padding-bottom: 9rem;
    };
  `,
);

export const Heading = styled(Typography)(
  ({ theme }) => `
    color: ${neutral[50]};

    ${theme.breakpoints.up('sm')} {
      font-size: 20vw;
    }
  `,
) as typeof Typography;

export const HeadingLight = styled('span')(`
  font-weight: normal;
  display: block;
`);

export const PelletImage = styled('div')(
  ({ theme }) => `
    height: 100%;
    mix-blend-mode: multiply;
    width: 75%;
    position: absolute;
    left: 50%;
    top: 0;
    opacity: 0.7;
    transform: translate(-50%, 0);

    ${theme.breakpoints.up('sm')} {
      width: 60%;
    };

    @media screen and (min-width: ${
      theme.breakpoints.values['sm']
    }px) and (orientation: landscape) {
      width: 55%;
    };

    @media screen and (min-width: ${
      theme.breakpoints.values['md']
    }px) and (orientation: landscape) {
      width: 50%;
    };

    @media screen and (min-width: ${
      theme.breakpoints.values['lg']
    }px) and (orientation: landscape) {
      width: 43%;
    };

    @media screen and (prefers-reduced-motion) {
      max-height: 50vh;
      object-fit: cover;
      object-position: center top;
      top: -50;
    }
  `,
);
export const ToutContent = styled(BaseToutContent)(
  ({ theme }) => `
    padding: 0 2.5rem;

    ${theme.breakpoints.up('md')} {
      padding: 0 ${Number(gutterFlexible) * 2}vw;
    }
  `,
);
